import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.pedidos_api.rappi;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// put /StartCookingOrder/<int:order_id>
export const startCookingOrder = async (orderId: string | undefined,pedidoId: number | undefined , cookingTime: number | undefined | null) => {
  return await retryWithBackoff(() => api.put(`/StartCookingOrder/${orderId}`, {cooking_time: cookingTime,
                                                          pedido_id: pedidoId
  }, {
  }));
};

// Store operations
export const getRappiStores = async () => {
  return await retryWithBackoff(() => api.get('/GetRappiStores'));
};

export const activateRappiStore = async (storeId: number) => {
  return await retryWithBackoff(() => api.post('/ActivateRappiStore', { store_id: storeId }));
};

// Menu operations
export const createRappiMenuFromLocalId = async (localId: number) => {
  return await retryWithBackoff(() => api.post(`/CreateRappiMenuFromLocalId/${localId}`));
};

// Token operations
export const getRappiToken = async (localId: number) => {
  return await retryWithBackoff(() => api.get(`/GetRappiToken/${localId}`));
};

// Webhook operations
export const setupRappiWebhook = async (data: {
  new_url: string;
  event: string;
  stores_list?: number[];
  local_id: number;
}) => {
  return await retryWithBackoff(() => api.post('/SetUpRappiWebhook', data));
};

export const addStoreToRappiWebhook = async (data: {
  store_id: number;
  event: string;
  webhook_url: string;
}) => {
  return await retryWithBackoff(() => api.post('/AddStoreToRappiWebhook', data));
};

export const getRappiWebhooks = async () => {
  return await retryWithBackoff(() => api.get('/GetRappiWebhooks'));
};
